import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "../reducer/reducer";

const store = configureStore({
  reducer: rootReducer,
  // No es necesario agregar redux-thunk ya que ya está incluido por defecto
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: process.env.NODE_ENV !== "production", // Habilitar Redux DevTools solo en entornos de desarrollo
});

export default store;
